import { useState } from "react";
import FullscreenCarousel from "@/components/common/FullscreenCarousel";
import Image from "@/components/common/Image";
import MultiColumnModule from "@/components/site-builder/MultiColumnModule";
import type { ImageGalleryModuleType } from "./types";
import Mapper from "./Mapper";

export interface ImageGalleryModuleProps {
  module: ImageGalleryModuleType;
}

export default function ImageGalleryModule(props: ImageGalleryModuleProps) {
  const { module } = props;
  const {
    body: { blocks, lightboxEnabled },
  } = module;

  const [selectedSlideIndex, setSelectedSlideIndex] = useState(-1);

  const handleCarouselOpen = (slideIndex: number) => {
    if (lightboxEnabled) {
      setSelectedSlideIndex(slideIndex);
    }
  };

  const handleCarouselClose = () => {
    setSelectedSlideIndex(-1);
  };

  return (
    <MultiColumnModule
      module={module}
      renderBlock={(block, index) => (
        <div onClick={() => handleCarouselOpen(index)}>
          <Mapper module={module} block={block} />
        </div>
      )}
    >
      <FullscreenCarousel
        open={selectedSlideIndex !== -1}
        items={blocks}
        renderItem={(block) => (
          <Image src={block.image.source?.path} alt={block.image.altText} />
        )}
        initialSlide={selectedSlideIndex}
        onClose={handleCarouselClose}
      />
    </MultiColumnModule>
  );
}
